import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DraggableWidgetDirective } from './draggable-widget.directive';
import { WidgetDropAreaDirective } from './widget-drop-area.directive';

export const EXPORT_COMPONENTS = [DraggableWidgetDirective, WidgetDropAreaDirective];

@NgModule({
  declarations: [...EXPORT_COMPONENTS],
  imports: [CommonModule],
  exports: [...EXPORT_COMPONENTS],
})
export class DragDropModule {}
